import { faFileShield, faTimeline } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { Link } from 'react-router-dom';

import useInsuranceDeepLinks from '@/hooks/useInsuranceDeepLinks';
import { Tooltip } from '@/ui';
import AuditLogLink from '@/ui/components/AuditLogLink';

import './styles.css';
import type { Props } from './types';

const iconLinkClassName =
  'inline-flex h-8 w-8 items-center justify-center rounded-md text-uniform-gray-600 hover:bg-uniform-gray-100 hover:text-uniform-gray-900 dark:text-uniform-gray-300 dark:hover:bg-uniform-gray-800';

const PolicyLinks = ({ policy, personId, className }: Props) => {
  const { billingTimelineUrl, vobListUrl } = useInsuranceDeepLinks(personId);

  if (!policy.id) return null;

  const timelineUrl = billingTimelineUrl(policy.id);
  const vobUrl = vobListUrl(policy.id);

  return (
    <nav
      aria-label={`${policy.carrier ?? 'Policy'} links`}
      className={`flex items-center gap-0.5 ${className ?? ''}`}>
      <Tooltip content="Audit history">
        <AuditLogLink
          entityType="insurancepolicy"
          entityId={policy.id}
          className={iconLinkClassName}
        />
      </Tooltip>
      {timelineUrl && (
        <Tooltip content="Billing & VOB Timeline for this policy">
          <Link
            to={timelineUrl}
            aria-label="Billing and VOB Timeline for this policy"
            className={iconLinkClassName}>
            <FontAwesomeIcon icon={faTimeline} className="h-4 w-4" />
          </Link>
        </Tooltip>
      )}
      {vobUrl && (
        <Tooltip content="VOB list for this policy">
          <Link to={vobUrl} aria-label="VOB list for this policy" className={iconLinkClassName}>
            <FontAwesomeIcon icon={faFileShield} className="h-4 w-4" />
          </Link>
        </Tooltip>
      )}
    </nav>
  );
};

export default React.memo(PolicyLinks);
